"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    tabSelected: {
        borderBottomColor: colors_1.default.BLUE,
        borderBottomWidth: 5,
    },
    tabNotSelected: {
        borderBottomColor: colors_1.default.WHITE,
        borderBottomWidth: 5,
    },
    tab: {
        height: 21,
        left: 39,
        top: 0,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 14,
        lineHeight: 21,
        /* identical to box height, or 150% */
        textAlign: 'center',
        textTransform: 'uppercase',
        /* Inside Auto Layout */
        flex: 0,
        borderWidth: 0,
        flexGrow: 0,
        marginVertical: 6,
        marginHorizontal: 0,
    },
});
exports.default = styles;
